import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { INDUSTRIES } from "@/data/content";
import { Eyebrow, Reveal } from "./Reveal";

const Tile = ({ item, i }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);
  return (
    <Reveal delay={i * 0.08} className={i % 2 ? "sm:mt-16" : ""}>
      <figure ref={ref} data-testid={`industry-${i}`} className="group relative">
        <div className="relative aspect-[3/4] overflow-hidden rounded-[24px] [clip-path:polygon(0_0,100%_0,100%_88%,82%_100%,0_100%)]">
          <motion.img style={{ y }} src={item.img} alt={item.name} className="absolute left-0 top-[-15%] h-[130%] w-full object-cover grayscale-[35%] transition-[filter] duration-700 group-hover:grayscale-0" />
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_35%,transparent_25%,rgba(6,26,61,0.6)_90%)]" />
        </div>
        <figcaption className="mt-4 flex items-center justify-between">
          <span className="font-display text-lg font-extrabold italic">{item.name}</span>
          <span className="font-mono text-xs text-[var(--ink)]/50">0{i + 1}</span>
        </figcaption>
      </figure>
    </Reveal>
  );
};

export const Industries = () => (
  <section id="industries" data-testid="industries-section" className="relative py-24 lg:py-32">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <Eyebrow>Who we fund</Eyebrow>
        <h2 className="mt-5 max-w-3xl font-display text-4xl font-black italic leading-[1] tracking-tight sm:text-5xl lg:text-6xl">
          Made for the businesses that <span className="text-brand-gradient">keep cities running.</span>
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        {INDUSTRIES.map((it, i) => <Tile key={it.name} item={it} i={i} />)}
      </div>
    </div>
  </section>
);
